import React, { useState } from 'react';
import WithContext from './components/Context/withContext';
import WithFormDataContext from './components/FormDataContext/WithFormDataContext';
import Form from './components/Form/Form';
import WithPathContext from './components/PathContext/PathContext';
import WithVehicleApplicationContext from './VehicleApplicationContext/WithVehicleApplicationContext';
import WarningModal from './components/WarningModal/WarningModal';

function App() {
  const [showWarning, setShowWarning] = useState(true);

  const handleAccept = () => {
    setShowWarning(false);
  };

  return (
    <div id="container">
      {showWarning && <WarningModal onAccept={handleAccept} />}
      <WithPathContext>
        <WithVehicleApplicationContext>
          <WithFormDataContext>
            <WithContext>
              <Form />
            </WithContext>
          </WithFormDataContext>
        </WithVehicleApplicationContext>
      </WithPathContext>
    </div>
  );
}

export default App;
